module.exports = __webpack_public_path__ + "media/images/flags/1x1/isr-bd8773e54a96e041c7d09059fbbca9f7.svg";